import { useSession } from "next-auth/react";
import { NextRouter, useRouter } from "next/router";
import { useCallback } from "react";
type option = {
    scroll?: boolean;
    shallow?: boolean;
}

/**
 * 종목 상세 페이지로 이동
 * @param ticker 종목 코드
 * @param method 이동 방법 (push: 히스토리 추가, replace: 히스토리 덮어쓰기)
 * @param options 이동 옵션
 */
export const routeToStockDetailPage = (router: NextRouter, ticker: string | null | undefined, method: 'push' | 'replace' = 'push', options?: option, tab?: undefined | 'score' | 'overview' | 'aireport' | 'info') => {
    const url = `/detail/${ticker}${tab ? `?tab=${tab}` : ''}`;

    if (!ticker) return;

    if (method === 'replace') {
        router.replace(url, undefined, options);
    } else {
        router.push(url, undefined, options);
    }

};


/**
 * 로그인 페이지로 이동
 * @param router 라우터 인스턴스
 * @param session 세션 인스턴스
 * @param forbidNotUser 비회원 접근 금지 여부 (기본값: true)
 */

export const toLoginPage = (router: NextRouter, parentIntent?: string) => {
    const callbackUrl = toLoginPageUrl(router, parentIntent);
    router.push(`/login?from=${encodeURIComponent(callbackUrl)}`);
}
export const toLoginPageUrl = (router: NextRouter, parentIntent?: string) => {
    const currentPath = router.asPath;
    const currentHasQuery = currentPath.includes("?");
    const parentIntentQuery = parentIntent ? `&parentIntent=${parentIntent}` : "";
    const callbackUrl = currentHasQuery ? `${currentPath}${parentIntentQuery}` : `${currentPath}?${parentIntentQuery}`;
    return `/login?from=${encodeURIComponent(callbackUrl)}`;
}

export const routeToLoginPage = (router: NextRouter, session: any | null | undefined, forbidNotUser: boolean = true) => {
    if (forbidNotUser && !session?.user?.email) {
        router.push(`/login?from=${encodeURIComponent(router.asPath)}`);
        return false;
    }
    if (!forbidNotUser) {
        return router.push(`/login?from=${router.asPath}`);
    }

};


/**
 * 리포트 상세 페이지로 이동
 * 
 * */
export const routeToReportDetailPage = (router: NextRouter) => {

    return router.push(``);
};


